import React, { useContext, useState } from "react";
import Button from "../../../Components/Button/button.component";
import { UserContext } from "../../../Providers/user-provider";
import { utils } from "xlsx"; // Import the xlsx library
import * as XLSX from "xlsx/xlsx.mjs";
import { GET_ALL_CONTACTS } from "./query";
import { useLazyQuery } from "@apollo/client";

const BulkContactDownload = ({ rootStore, filters }) => {
	const userContext = useContext(UserContext);
	const [downloadInProgress, setDownloadInProgress] = useState(false);
	const [bulkDownloadDisabled, setBulkDownloadDisabled] = useState(
		userContext.role !== "orgadmin"
	);

	const [
		fetchContacts, // <-- call this inside your function
		{ loading, error, data: fetchData, refetch },
	] = useLazyQuery(GET_ALL_CONTACTS, {
		fetchPolicy: "network-only",
	});

	function handleDownload() {
		setDownloadInProgress(true);
		const workbook = XLSX.utils.book_new();
		fetchContacts({
			variables: {
				offset: 0,
				order_by: { Name: "asc" },
			},
		}).then((response) => {
			const contacts = response.data.msgbox_Contact;
			const opts = {
				year: "numeric",
				month: "short",
				day: "numeric",
				hour: "2-digit",
				minute: "2-digit",
			};
			const rows = contacts.map((contact) => {
				const date = new Date(contact?.CreatedOn);
				let obj = {
					Name: contact?.Name,
					"Phone Number": contact?.MobileNumber,
					Status: contact?.Status,
					CreatedOn: date.toLocaleString("en-GB", opts),
				};
				if (contact.TagContacts && contact.TagContacts.length > 0) {
					for (let i = 0; i < contact?.TagContacts?.length; i++) {
						obj[`Tag_${i + 1}`] =
							contact?.TagContacts[i]?.Tag?.Name;
					}
				}
				return obj;
			});
			const worksheet = XLSX.utils.json_to_sheet(rows, {});
			utils.book_append_sheet(workbook, worksheet, "Contacts");
			XLSX.writeFile(workbook, "Contacts.xlsx");
		});

		///

		setDownloadInProgress(false);
	}

	return (
		<>
			{userContext.role === "orgadmin" && (
				<>
					<Button
						title={
							bulkDownloadDisabled
								? "Contact your reseller to upgrade"
								: "Add Contacts"
						}
						primary
						buttonName="Download Contacts"
						onClick={() => {
							handleDownload();
						}}
						disabled={bulkDownloadDisabled || downloadInProgress}
					/>
				</>
			)}
		</>
	);
};

export default BulkContactDownload;
